import { styled } from "@mui/system";
import Button from "@mui/material/Button";

const SecondaryButton = styled(Button)`
  && {
    background: #ffffff;
    color: #1e50c4;
    border: 1.5px solid rgba(30, 80, 196, 0.8);
    border-radius: 6px;
    box-shadow: 0 1px 3px rgba(30, 80, 196, 0.15);
    text-transform: capitalize;
    min-width: 6.5rem;
    width: fit-content;
    padding: 0.55rem 1rem;
    font-weight: 500;
    letter-spacing: 0.25px;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background: #eef3ff;
      box-shadow: 0 4px 12px rgba(30, 80, 196, 0.25);
      transform: translateY(-1px);
    }

    &:active {
      transform: translateY(0);
      box-shadow: 0 1px 3px rgba(30, 80, 196, 0.2);
    }

    &:disabled {
      background: #f2f2f2;
      color: #9e9e9e;
      border-color: #bdbdbd;
      box-shadow: none;
      cursor: not-allowed;
      transform: none;
    }
  }
`;

export default SecondaryButton;
